import { Injectable } from '@angular/core';
import { CheckoutQueryService } from "@spartacus/checkout/base/core";

@Injectable({
  providedIn: 'root',
})
export class ValioCheckoutDetailsService extends CheckoutQueryService {

}
